import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { FormatUtilities } from '../utilities/format-utilities';
import { UnitProgressDetail, ActivityResult, Encounter } from '../data/student-report';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-strand-unit-report',
  templateUrl: './strand-unit-report.component.html',
  styleUrl: './strand-unit-report.component.scss'
})
export class StrandUnitReportComponent extends BaseComponent implements OnInit, OnChanges {
  @Input() studentID: number;
  @Input() unitNumber: number;
  @Input() courseCode: string;
  unitDetails: UnitProgressDetail;
  selectedActivity: ActivityResult;
  completeOrActivitiesWithArtifacts: ActivityResult[];
  activityListLineBreak: number;

  displayTime = FormatUtilities.displayTimeWithoutSeconds;
  displaySkillConcept = FormatUtilities.displaySkillConcept;
  mappedDescriptions = new Map<string, Array<string>>();
  get highestCompletedActivityInUnit(): ActivityResult {
    var highestActivity = this.unitDetails.ActivityResults.slice().reverse().find(ar => ar.IsComplete);
    return highestActivity ? highestActivity : this.unitDetails.ActivityResults[0];
  }

  ngOnChanges() {
    this.unitDetails = null;
    this.dataService.getStudentUnitProgress(this.studentID, this.courseCode, this.unitNumber).subscribe(upd => {
      this.unitDetails = upd;
      this.selectedActivity = this.highestCompletedActivityInUnit;
      this.mappedDescriptions.clear();

      this.unitDetails.ActivityResults.filter(e => e.Encounters).forEach(ar => {
        ar.Encounters.forEach(e => {
          if (!this.mappedDescriptions.has(e.SkillType)) this.mappedDescriptions.set(e.SkillType, new Array<string>());
          
          if(e.SkillConcept && !e.SkillConcept.includes("_") && !this.mappedDescriptions.get(e.SkillType).includes(e.SkillConcept)) this.mappedDescriptions.get(e.SkillType).push(e.SkillConcept);
        });
      });

      this.mappedDescriptions.forEach(k => {k.sort()});

      var activityResults = this.unitDetails.ActivityResults;
      var hasCompleted = false;

      for (let i = activityResults.length - 1; i >= 0; i--) {
        if (activityResults[i].IsComplete || (activityResults[i].GeneratedArtifacts && activityResults[i].GeneratedArtifacts.length > 0)) {
          hasCompleted = true;
        } else if (hasCompleted && !activityResults[i].IsComplete) {
          activityResults.splice(i, 1);
        }
      }

      if (this.courseCode == "OlderBeginner") {
        this.activityListLineBreak = Math.round((activityResults.length / 2) + 0.5);
      }
      else {
        this.activityListLineBreak = activityResults.length;
      }
    });
  }

  selectActivity(activityResult: ActivityResult): void {
    this.selectedActivity = activityResult;
  }

  isSelected(activityResult: ActivityResult): boolean {
    return this.selectedActivity === activityResult;
  }
}
